export default __webpack_public_path__ + "static/media/possiblesTest.a483df4b.jpg";